import React from 'react';

const FIELDS = [
    { key: 'name', placeholder: 'Имя' },
    { key: 'sname', placeholder: 'Фамилия' },
    { key: 'ot', placeholder: 'Отчество' },
    { key: 'email', placeholder: 'E-mail', type: 'email' },
    { key: 'phone', placeholder: 'Телефон', type: 'tel' },
    { key: 'sphone', placeholder: 'Телефон родителей', type: 'tel' },
    { key: 'city', placeholder: 'Город' },
    { key: 'cityW', placeholder: 'Место тренировок' },
    { key: 'bday', placeholder: 'Дата рождения', type: 'date' }
];

export default function StudentCreateForm({
    formData,
    loading,
    onUpdateField,
    onCreate
}) {
    return (
        <section className="create-student-section">
            <div className="student-form">
                <h2>Создание аккаунта ученицы</h2>

                <div className="form-grid">
                    {FIELDS.map(field => (
                        <input
                            key={field.key}
                            type={field.type || 'text'}
                            value={formData[field.key]}
                            onChange={(e) => onUpdateField(field.key, e.target.value)}
                            placeholder={field.placeholder}
                            className="form-input"
                        />
                    ))}
                </div>

                <textarea
                    value={formData.about}
                    onChange={(e) => onUpdateField('about', e.target.value)}
                    placeholder="О ученице"
                    rows="3"
                    className="form-textarea"
                />

                <textarea
                    value={formData.char}
                    onChange={(e) => onUpdateField('char', e.target.value)}
                    placeholder="Характеристика от тренера"
                    rows="3"
                    className="form-textarea"
                />

                <button
                    onClick={onCreate}
                    disabled={loading}
                    className="btn-primary"
                >
                    {loading ? 'Создание...' : 'Создать'}
                </button>
            </div>
        </section>
    );
}
